<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      :show-save-button="false"
      title="选单"
      id-key="PurchaseDemandId"
      @close-saved="$emit('close-saved')"
    >
      <el-tabs
        v-model="activeName"
        type="card"
      >
        <el-tab-pane label="车间余料解绑明细表" name="tab1">
          <list
            ref="list1"
            row-key="PurchaseDemandId1"
            :page="page"
            :show-query="true"
            :get-data-func="api.vDetail"
            :query-params="params"
            :reset-data-func="resetDataFunc1"
          >
            <template slot="query">
              <el-form-item label-width="120px" label="转出工单解绑号">
                <el-input
                  class="Text"
                  clearable
                  v-model="params.DocNo"
                  placeholder="请输入转出工单解绑号"
                />
              </el-form-item> 
              <el-form-item label-width="120px" label="存货名称">
                <el-input
                  clearable
                  v-model="params.ProductName"
                  placeholder="存货名称"
                  class="Text"
                />
              </el-form-item>
              <el-form-item label-width="120px" label="规格"> 
                <el-input
                  clearable
                  v-model="params.ProductSpec"
                  placeholder="存货名称"
                  class="Text"
                />
              </el-form-item>
              <el-form-item label-width="120px" label="属性"> 
                <el-input
                  clearable
                  v-model="params.PropertyName"
                  placeholder="属性"
                  class="Text"
                />
              </el-form-item>
              <el-form-item label-width="120px" label="颜色"> 
                <el-input
                  clearable
                  v-model="params.ColorName"
                  placeholder="颜色"
                  class="Text"
                />
              </el-form-item>
            </template>

            <template slot="table">
              <el-table-column
                prop="Sn"
                label="序号"
                min-width="120"
                align="left"
                key="key1"
              />
              <el-table-column
                prop="DocDate"
                label="解绑日期"
                min-width="120"
                align="left"
                key="key2"
              >
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toDateString(row.DocDate) }}</span>
              </template>
              </el-table-column>
              <el-table-column
                prop="DocNo"
                label="解绑单号"
                min-width="120"
                align="left"
                key="key3"
              />
              <el-table-column
                prop="ProductName"
                label="材料名称"
                min-width="120"
                align="left"
                key="key4"
              ></el-table-column>
              <el-table-column
                prop="ProductNo"
                label="材料编码"
                min-width="120"
                align="left"
                key="key5"
              />
              <el-table-column
                prop="ProductSpec"
                label="规格"
                min-width="120"
                align="left"
                key="key6"
              ></el-table-column>
              <el-table-column
                prop="PropertyName"
                label="属性"
                min-width="120"
                align="left"
                key="key7"
              ></el-table-column>
              <el-table-column
                prop="ColorName"
                label="颜色"
                min-width="120"
                align="left"
                key="key8"
              ></el-table-column>
              <el-table-column
                prop="BaseQuantity"
                label="主数量"
                min-width="120"
                align="right"
                key="key9"
              ></el-table-column>
              <el-table-column
                prop="Quantity"
                label="转出数量"
                min-width="120"
                align="right"
                key="key10"
              ></el-table-column>
              <el-table-column
                label="操作"
                min-width="80"
                align="center"
                key="key11"
                fixed="right"
              >
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  @click="select(row)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
            </template>
          </list>
        </el-tab-pane>
        <el-tab-pane label="转入工单" name="tab2">
          <list
            ref="list2"
            row-key="PurchaseDemandId2"
            :page="page"
            :show-query="true"
            :get-data-func="workDocApi.getTransferWorkDocList"
            :query-params="params1"
            :reset-data-func="resetDataFunc1"
          >
            <template slot="query">
              <el-form-item label-width="120px" label="转入工单号">
                <el-input
                  class="Text"
                  clearable
                  v-model="params1.WorkDocNo"
                  placeholder="请输入转入工单号"
                />
              </el-form-item> 
              <el-form-item label-width="100px" label="查询时间" > 
                <range-picker
                  ref="picker"
                  @change="
                    (x) => {
                      params1.DocDateStart = x.Start;
                      params1.DocDateEnd = x.End;
                    }
                  "
                  style="min-width:260px"
                >
                </range-picker>
              </el-form-item>
            </template>

            <template slot="table">
              <el-table-column
                prop="Sn"
                label="序号"
                min-width="120"
                align="left"
                key="key1"
              />
              <el-table-column
                prop="DocDate"
                label="单据时间"
                min-width="120"
                align="left"
                key="key2"
              >
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toDateString(row.DocDate) }}</span>
              </template>
              </el-table-column>
              <el-table-column
                prop="WorkDocNo"
                label="工单号"
                min-width="120"
                align="left"
                key="key3"
              />
              <el-table-column
                label="操作"
                min-width="80"
                align="center"
                key="key11"
              >
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  @click="select1(row)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
            </template>
          </list>
        </el-tab-pane>
      </el-tabs>

      <template slot="footer">
        <el-button  @click="closed">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import listMixin from "@/mixins/list";
import commonDialog from "@/components/common/dialog";
import list from "@/components/common/list";

export default {
  mixins: [editDialogMixin, listMixin],
  components: {
    commonDialog,
    list,
  },
  data() {
    return {
      api: require('@/api/production/unBindMaterial').default,
      workDocApi: require('@/api/production/workDoc').default,
      params: {
        DocNo: "", 
        ProductName: "",
        ProductSpec: "",
        PropertyName: "",
        ColorName: "",
      },
      params1: {
        WorkDocNo: "", 
        DocDateStart: "",
        DocDateEnd: "",
      },
      DocNo: null,
      ProductId: null,
      activeName: "tab1",
      detailRow: null,
    };
  },
  methods: {
    resetDataFunc1(data){
      data.forEach((item, index) => {
        item.Sn = index + 1;
      })

      console.log('data', data)

      return data
    },
    closed() {
      this.clear();
      this.close();
    },
    getData(){
      this.clear();
      this.$refs.list1.getData();
      // this.$refs.list2.getData();
    },
    clear(){
      this.ProductId = null;
      this.DocNo = null;
      this.$refs.list1.data = [];
      this.$refs.list2.data = [];
      this.activeName = 'tab1'
      
    },
    select(row){
      console.log('row1', row)
      this.detailRow = row;
      this.ProductId = row.ProductId;
      this.DocNo = row.DocNo;
      this.$refs.list2.getData({ProductId: this.ProductId, ...this.params1});
      this.activeName = 'tab2'
    },
    select1(row){
      let o = {
        DocNo: this.DocNo,
        data: row,
        detailRow: this.detailRow,
      }

      this.$emit('select', o)

      this.clear();
      this.close();
    },
   
  },
};
</script>
<style lang="scss" scoped>
/deep/ .Text .el-input__inner {
  width: 260px !important;
}
/deep/ .IsExecute .el-input .el-input__inner {
  width: 160px;
}
</style>
